/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
    $('.myColorSwatch__Radio').on('change', updateMyButton);
    $('.mySizeSwatch__Radio').on('change', updateMyButton);
    function updateMyButton() {
        var $form = $(this).closest('form');
        var color = $form.find('.myColorSwatch__Radio:checked').val();
        var size = $form.find('.mySizeSwatch__Radio:checked').val();
        var $option = $form.find('option[my_color="' + color.replace(' ', '\\ ') + '"][my_size="' + size.replace(' ', '\\ ') + '"]');
        var $button = $form.find('.myProductForm__AddToCart');
        if ($option.length == 1 && !$option.prop('disabled')) {
            $option.prop('selected', true);
            $button.text('ADD');
            $button.prop('disabled', false);
        } else {
            $button.text('SOLD OUT');
            $button.prop('disabled', true);
        }
    }
});
